<template>
	<div id="panel_programs" class="panel announces">
		<div class="container">
			<div v-if="headerName" class="panel_header">
				<div class="row align-items-end">
					<div class="col-12 col-lg-12">
						<h2>{{ headerName }}</h2>
					</div>
				</div>
				<!--<nuxt-link class="panel_control" to="#"></nuxt-link>-->
			</div>
			<ul class="announce_list">
				<li v-for="item in items" :key="item.id" class="row">
					<div class="col-12 col-sm-4 col-lg-2">
						<div class="announce_date_block">
							<div class="row">
								<div class="col-6 col-sm-12">
									<div class="announce_date_day">
										<span>{{ item.event_date | moment('DD') }}</span>
										<a
											:href="'//sk.skolkovo.ru/api/calendar/event/' + item.id"
											class="add_announce"
											aria-label="Добавить в календарь"
										/>
									</div>
									<div class="">
										<div class="announce_date_properties">
											<div class="announce_date_month">
												{{ item.event_date | moment('MMMM') }}
											</div>
											<div class="announce_date_time">
												{{ item.event_date | moment('HH:mm') }}
											</div>
											<div class="announce_date_month mt-3">
												{{ item.event_date | moment('YYYY') }}
											</div>
											<!--<div class="announce_date_weekday">среда</div>-->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 col-sm-8 col-lg-4">
						<div class="announce_image_block">
							<nuxt-link :to="$url.event(item.slug, item.typology_slug)">
								<img
									:src="item.listing_cover_image_default.length !== 0 ? item.listing_cover_image_url_small : item.top_cover_image_url_small"
									:alt="item.title"
								>
							</nuxt-link>
						</div>
					</div>
					<div class="col-12 col-lg-6">
						<div class="announce_content_block">
							<div class="announce_content_header">
								<!-- тип мероприятия (вроде есть), проект, продукт, профильный раздел -->
								<ul class="tag_list">
									<li>
										<nuxt-link :to="$url.events({ query: { type:item.type } })">
											{{ item.type_titles.title_default }}
										</nuxt-link>
									</li>
									<li v-if="item.taxonomy && item.taxonomy.project">
										<nuxt-link
											:to="$url.events({ query: { taxonomy_project: item.taxonomy.project.id } })"
										>
											{{ item.taxonomy.project.title }}
										</nuxt-link>
									</li>
									<li v-if="item.taxonomy && item.taxonomy.product">
										<nuxt-link
											:to="$url.events({ query: { taxonomy_product: item.taxonomy.product.id } })"
										>
											{{ item.taxonomy.product.title }}
										</nuxt-link>
									</li>
									<li v-for="section in item.taxonomy.sections" :key="section.title">
										<nuxt-link :to="$url.events({ query: { taxonomy_section: section.id } })">
											{{ section.title }}
										</nuxt-link>
									</li>
								</ul>
								<!--<div class="announce_reminder">
									<nuxt-link to="#">через X дней</nuxt-link>
								</div>-->
							</div>
							<div class="announce_content_middle">
								<nuxt-link
									:to="$url.event(item.slug, item.typology_slug)"
									class="title announce_title"
								>
									{{ item.title }}
								</nuxt-link>
								<p class="description">
									{{ item.subtitle }}
								</p>
							</div>
							<div class="announce_content_footer">
								<nuxt-link
									:to="$url.event(item.slug, item.typology_slug)"
									class="more_link"
								>
									Детали и регистрация
								</nuxt-link>
								<!--<div class="announce_content_footer_reminder">осталось XX дней</div>-->
							</div>
						</div>
					</div>
				</li>
			</ul>
			<div v-if="showMeta" class="panel_footer">
				<div class="row">
					<div class="col-12 col-md-4 col-lg-2">
						<a
							href="/navigator/programmes/"
							class="btn btn-primary mb-4"
						>Все программы</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import '@/utils/moment';
import ucFirst from '@/utils/ucFirst';

const DEFAULT_TITLE = 'Программы';

export default {
	name: 'ProgramsNavigatorItems',
	props: {
		items: { type: Array, required: true },
		showMeta: { type: Boolean, default: false },
		category: { type: String, default: '' },
		title: { type: String, default: '' },
	},
	data() {
		return {
			announceMore: false,
		};
	},
	computed: {
		headerName() {
			if (this.title) return this.title;
			if (this.showMeta) return DEFAULT_TITLE;
			return '';
		},
	},
	methods: {
		topicsToString(topics) {
			return ucFirst(topics.map(
				({ title }) => title,
			).join(', '));
		},
	},
};
</script>

<style lang="scss" scoped>
	@import '~/assets/styles/components/home/panel-announces';
</style>
